/* @ngInject */

export default ($q, $http, logger, QUICK_TOOL) => {
  /**
   * Get Astute Commission.
   *
   * @param {Object} [params]
   *
   * @returns {Array}
   */
  const getBase64FromImageUrl = (params) => {
    const deferred = $q.defer();
    logger.log('quickToolDataFactory', 'getBase64FromImageUrl', 'Resolving data from API');
    $http.post(QUICK_TOOL.API.GENERATE_BASE64_FROM_IMAGE_URL, { params }).then(
      (payload) => {
        logger.debug('quickToolDataFactory', 'getBase64FromImageUrl', 'Resolved data from API');
        deferred.resolve(payload.data);
      },
      (err) => {
        logger.error(
          `quickToolDataFactory | getBase64FromImageUrl | Error while resolving data ${err}`
        );
        deferred.reject();
      }
    );
    return deferred.promise;
  };

  return {
    getBase64FromImageUrl
  };
};
